<template>
	<b-card class="p-2 container days-counter" no-body>
		<h3 class="text-uppercase">{{ title }}</h3>
		<b-row>
			<b-col class="my-1" cols="12" md="11" style="margin-left: auto; margin-right: auto">
				<b-form-group :label="label">
					<vue-number-input center vertical controls v-model="localAge" :min="1" />
				</b-form-group>
			</b-col>
		</b-row>
		<b-row>
			<b-col class="text-right">
				<b-button
					size="lg"
					variant="success"
					@click="$emit('save', localAge)"
					:disabled="isLoading || localAge == null || localAge == age"
				>
					Guardar
				</b-button>
			</b-col>
		</b-row>
	</b-card>
</template>
<script>
export default {
	name: "AgeCard",
	props: {
		title: {
			type: String,
			required: true,
		},
		label: {
			type: String,
			required: true,
		},
		age: {
			type: Number || null,
		},
		minAge: {
			type: Number,
			default: 1,
		},
	},
	data: () => ({
		isLoading: false,
		localAge: 0,
	}),
	computed: {},
	methods: {},
	mounted() {
		if (this.age) {
			this.localAge = this.age
		} else {
			this.localAge = this.minAge
		}
	},
}
</script>
<style scoped>
.container {
	margin: auto auto;
	width: 100%;
}

@media screen and (min-width: 1024px) {
	.container {
		width: 30%;
	}
}

@media screen and (min-width: 1024px) {
	.days-counter {
		width: 25%;
	}
}
</style>
